<template>
  <main-layout>
    <div class="relative pt-16 pb-20 px-4 sm:px-8 lg:pt-24 lg:pb-28 lg:px-12 min-h-screen">
      <div class="absolute inset-0">
        <div class="h-1/3 sm:h-2/3"></div>
      </div>
      <div class="relative max-w-7xl mx-auto">
        <div class="text-center">
          <h2
            class="text-3xl leading-9 tracking-tight font-extrabold text-gray-900 sm:text-4xl sm:leading-10"
          >Tools for Remote Work</h2>
          <p
            class="my-4 max-w-2xl mx-auto text-xl leading-7 text-gray-500 sm:mt-4"
          >A curated list of great tools for remote workers</p>
          <input
            aria-label="Search"
            type="text"
            ref="search"
            required
            class="mt-4 appearance-none w-full px-4 py-2 border border-gray-300 text-base leading-6 rounded-md text-gray-900 bg-white placeholder-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out lg:max-w-xs"
            placeholder="Search on name or category"
            v-model="searchText"
          />
        </div>

        <section v-if="errored">
          <p>
            We're sorry, we're not able to retrieve this information at the
            moment, please try back later
          </p>
        </section>

        <section v-if="isFiltering" class="fixed top-5 rounded-lg shadow bg-white px-6 py-3">
          <span class="font-bold">Filters:</span>
          <span
            v-for="(tag, i) in filterTags"
            v-bind:key="i"
            v-on:click="removeFilterTag(tag)"
            class="cursor-pointer mr-1 px-4 py-1 rounded-full text-sm font-lg leading-5 bg-indigo-100 text-indigo-800"
          >
            {{ tag }}
            <span>x</span>
          </span>
        </section>

        <section v-if="!errored">
          <transition-group
            name="list"
            tag="div"
            class="mt-6 grid gap-16 pt-16 lg:grid-cols-3 lg:col-gap-5 lg:row-gap-12"
          >
            <a
              v-for="(tool, i) in searchText.length ? searchedTools : tools"
              v-bind:key="i"
              class="p-6 rounded-lg shadow-lg bg-white"
              v-bind:href="tool.link"
              target="_blank"
            >
              <div>
                <div class="flex justify-center md:justify-end -mt-16">
                  <img
                    class="w-20 h-20 object-cover rounded-full border-2 border-indigo-500"
                    v-bind:src="tool.logo"
                  />
                </div>
                <div>
                  <span
                    class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium leading-5 bg-indigo-100 text-indigo-800"
                  >{{tool.category}}</span>
                </div>
                <a v-bind:href="tool.link" target="_blank" class="block">
                  <h3 class="mt-4 text-xl leading-7 font-semibold text-gray-900">{{tool.name}}</h3>
                  <p class="mt-3 text-base leading-6 text-gray-600">{{ tool.description }}</p>
                </a>
                <!-- <div class="mt-6 flex items-center">
                  <div class="flex-shrink-0">
                    <a href="#">
                      <img
                        class="h-10 w-10 rounded-full"
                        src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                        alt
                      />
                    </a>
                  </div>
                  <div class="ml-3">
                    <p class="text-sm leading-5 font-medium text-gray-900">
                      <a href="#">Paul York</a>
                    </p>
                    <div class="flex text-sm leading-5 text-gray-500">
                      <time datetime="2020-03-16">Mar 16, 2020</time>
                      <span class="mx-1">&middot;</span>
                      <span>6 min read</span>
                    </div>
                  </div>
                </div>-->
              </div>
            </a>
          </transition-group>
        </section>
      </div>
    </div>
  </main-layout>
</template>

<script>
import dayjs from "dayjs";
import marked from "marked";
import relativeTime from "dayjs/plugin/relativeTime";
import MainLayout from "../layouts/Main.vue";

import tools from "./tools";

export default {
  name: "JobList",
  components: {
    MainLayout
  },
  data() {
    return {
      tools: [],
      // filteredJobs: [],
      // allJobs: [],
      // isLoading: false,
      // isFiltering: false,
      // filterTags: [],
      searchText: "",
      errored: false
      // limit: 30
    };
  },

  methods: {
    marked: function(input) {
      return marked(input);
    }
  },
  computed: {
    searchedTools() {
      const searchText = this.searchText.toLowerCase();
      return this.tools.filter(tool => {
        return (
          tool.name.toLowerCase().includes(searchText) ||
          tool.category.toLowerCase().includes(searchText)
        );
      });
    }
  },
  created() {
    dayjs.extend(relativeTime);
  },
  filters: {
    diffForHumans: date => {
      if (!date) {
        return null;
      }

      return dayjs(date).fromNow();
    }
  },
  // mixins: {
  //   marked: function(input) {
  //     return marked(input);
  //   },
  // },
  async mounted() {
    this.$refs.search.focus();

    this.tools = tools;
  }
};
</script>
<style scoped>
.loader {
  border-top-color: #4b5563;
  -webkit-animation: spinner 1.5s linear infinite;
  animation: spinner 1.5s linear infinite;
}

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.list-enter-active,
.list-leave-active {
  transition: all 0.6s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
</style>
